export default "<div class=\"wrapper\">\r\n\t<div class=\"value\">\r\n\t\t{{ goal.value }}\r\n\t</div>\r\n</div>\r\n"